import api from "api";

const otpUsers = {
    login:  (otp_code) =>
        api().post('/otp/login', { otp_code }),
    list:   (slug) =>
        api().get(`/establishments/${slug}/otp-users`),
    create: (slug, payload) =>
        api().post(`/establishments/${slug}/otp-users`, payload),
    delete: (slug, id) =>
        api().delete(`/establishments/${slug}/otp-users/${id}`),
};

export default otpUsers;
